import type { GridRowSelectionModel } from '@mui/x-data-grid'
import type { OpenModal } from './hooks/useModal'

export interface MediaToRefresh {
  mediaId: string
  mediaCode: number
  mediaNumber: string
  title: string
  status: MediaStatus
  mediaType: MediaType
  secureDate: string | null
  verifiedDate: string | null
  ownerCwsId: string
  ownerName: string
  ownerEmail: string
  needsVerified: boolean
  isOwnerAdmin: boolean
  id: number
}

export type MediaStatus = keyof typeof MediaStatusLabels

export const MediaStatusLabels = {
  C: 'Current',
  N: 'Non-Current',
} as const

export type MediaType = keyof typeof MediaTypeLabels

export const MediaTypeLabels = {
  D: 'Document',
  I: 'Image',
  V: 'Video',
} as const

export interface MediaToRefreshResults {
  totalCount: number
  results: MediaToRefresh[]
}

export interface MediaGrid {
  paginationRequest: StaleMediaPaginationRequest
  setPaginationRequest: SetPaginationRequest
  selectionModel: GridRowSelectionModel
  setSelectionModel: SetSelectionModel
  searchText: string
  setSearchText: SetSearchText
  staleMedia: StaleMedia
}

export interface StaleMediaPaginationRequest {
  Filter: string
  Skip: number
  Take: number
  OrderBy: string
  OrderByOrder: 'asc' | 'desc' | null | undefined
}

export type SetPaginationRequest = React.Dispatch<
  React.SetStateAction<StaleMediaPaginationRequest>
>

export type SetSelectionModel = React.Dispatch<
  React.SetStateAction<GridRowSelectionModel>
>

export type SetSearchText = React.Dispatch<React.SetStateAction<string>>

export interface StaleMedia {
  gridMode: GridMode | null
  mediaLoading: boolean
  rows: MediaToRefreshResults
}

export type MediaGridProps = MediaGrid & { openModal: OpenModal }

export type GridMode = 'server' | 'client'
